import { Route, Routes } from "react-router-dom";
import { AppDetailsOverview } from "src/components/AppDetailsOverview";
import { AppDocumentList } from "src/components/AppDocumentList";
import { AppOverviewShell } from "src/components/AppOverviewShell";
import { useActiveApplicantApplicationQuery } from "src/hooks/useApplication";
import IncomeVerify from "../screens/income-verify";

import _ from "lodash";

/**
 * inner tabs w/ routes
 */
export function PreFundedAppOverviewShell() {
  const { app, isLoading: loading } = useActiveApplicantApplicationQuery();

  return (
    <>
      <AppOverviewShell
        linkPrefix="/"
        title="App details"
        app={app || undefined}
        loading={loading}
        tabs={["overview", "doc-list", "income-verify"]}
      />
    </>
  );
}

export function AppDetailsRoutes() {
  const { app } = useActiveApplicantApplicationQuery();

  return (
    <Routes>
      <Route path="/" element={<PreFundedAppOverviewShell />}>
        <Route index element={<AppDetailsOverview applicationId={app?.id} />} />
        <Route
          path="doc-list"
          element={<AppDocumentList permissions={["delete"]} applicationId={app?.id} />}
        />
        <Route path="income-verify" element={<IncomeVerify />} />
      </Route>
    </Routes>
  );
}
